import { render, staticRenderFns } from "./TabModule.vue?vue&type=template&id=3a3f7e32&scoped=true"
import script from "./TabModule.vue?vue&type=script&lang=js"
export * from "./TabModule.vue?vue&type=script&lang=js"
import style0 from "./TabModule.vue?vue&type=style&index=0&id=3a3f7e32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f7e32",
  null
  
)

export default component.exports